import img from '../img/elevation_img_17.avif';
import img2 from '../img/hall_img_1.avif';
import img3 from '../img/living_room_img_2.avif';
import img4 from '../img/living_room_img_3.avif';
import img5 from '../img/kitchen_img_3.avif';
import blueprintImage from '../img/blueprint-4056027_1920.avif'; 
import biharcostImage from '../img/elevation_img_21.avif';
import smallHouseImage from '../img/elevation_img_7.avif';
import vastuShastraImage from '../img/room_img_3.avif';
import strongHouseImage from '../img/elevation_img_29.avif';
import housePlanningImage from '../img/floor_plan_5.avif';
import blenderSceneImage from '../img/dinning_area.webp';
import simpleHousePlanImage from '../img/floor_plan_6.avif';
import imgfree_house from '../img/elevation_img_18.avif'; // Use a relevant image
import checklistImage from '../img/office_ortho_2.avif';
import smallOfficeAfterImage from '../img/small_office_after.avif';
import mainEntranceImage from '../img/office_ortho_2.avif';
import kitchenImage from '../img/kitchen_img_5.avif';
import multiStoreyImage from '../img/floor_plan_7.avif';
import bihariArchitectureImage from '../img/collapsible_desk.avif';
import officeImage1 from '../img/office_ortho.avif';
import kictchenimg from '../img/kitchen_img_8.avif';
export const blogPostsData = [
  {
    id:'kitchen-desings',
    title:'Designing Your Dream Kitchen: A Blend of Style and Functionality',
    excerpt:
      'Explore the latest trends and essential tips for creating a beautiful and highly functional kitchen interior, from modular designs to smart storage solutions.',
    tags: ['kitchen design', 'interior design', 'modular kitchen', 'kitchen trends', 'smart kitchen', 'storage solutions', 'Patna home'],
    imageUrl:kictchenimg,
    link:'/blog/Kitcheninteriordesign',
    publishedDate: '2025-06-03T05:40:00+05:30', // Current date and time
    modifiedDate: '2025-06-03T05:40:00+05:30', // Current date and time
    author: 'Housekaar',
  },
  {
    id:'construction_challenges',
    title: 'Building Dreams, Avoiding Nightmares: Common Construction Challenges',
    excerpt:
      'Discover common pitfalls in house construction projects, from budget overruns to unexpected delays, and learn practical strategies to overcome them successfully.',
    tags: ['construction', 'challenges', 'home building', 'renovation', 'mistakes', 'budget', 'delays', 'quality control'],
    imageUrl: mainEntranceImage,
    link:'/blog/constructionchallenges',
    publishedDate: '2025-06-03T10:00:00+05:30', // Updated to current date
    modifiedDate: '2025-06-03T10:00:00+05:30', // Updated to current date
    author: 'Housekaar',
  },
  {
    id:'blogint',
    title: 'Beyond the Walls: Crafting Spaces that Inspire – Office & Room Interior Design',
    excerpt:
      'Discover how thoughtful interior design can transform your office and home into environments that boost productivity, promote well-being, and reflect your unique style. Learn key principles for creating inspiring spaces.',
    tags: ['interior design', 'office design', 'room design', 'home decor', 'workspace design', 'productivity', 'well-being', 'design tips', 'modern design', 'inspiration'],
    imageUrl: officeImage1,
    link:'/blog/interior-design', // Use an appealing office image for the main featured image
    publishedDate: '2025-05-24', // Current date
    modifiedDate: '2025-05-24', // Current date
    author: 'Housekaar', // Assuming "Housekaar" is the author for this blog too
  },
  {
    id:'bihar-arch',
    title: 'Integrating Traditional Bihari Architecture with Modern Vastu Principles',
    excerpt:
      "Explore how to blend the timeless charm of traditional Bihari architecture with modern Vastu principles. Create a harmonious and culturally rich home that fosters positive energy.",
    tags: ['Bihari architecture', 'traditional architecture', 'Vastu principles', 'modern home design', 'courtyard homes', 'sustainable architecture', 'Bihar home design', 'cultural heritage'],
    imageUrl: bihariArchitectureImage,
    link:'/blog/integrating-traditional-bihari-architecture-modern-vastu',
    publishedDate: '2025-05-22',
    modifiedDate: '2025-05-22',
    author: 'Housekaar',
  },
  {
    id:'mutli-storey',
    title: 'Multi-storey House Plans in Bihar: G+1 and G+2 Options for Growing Families & Rental Income',
    excerpt:
      'Explore G+1 and G+2 house plans for your home in Bihar, ideal for growing families or generating rental income. Discover the benefits, considerations, and key aspects of multi-storey designs for optimal space utilization.',
    tags: ['multi-storey house plans', 'G+1 house plans Bihar', 'G+2 house plans Bihar', 'rental income Bihar', 'growing families house plans', 'Bihar home design', 'space optimization', 'residential architecture Bihar'],
    imageUrl: multiStoreyImage,
    link:'/blog/multi-storey-house-plans-bihar',
    publishedDate: '2025-05-22',
    modifiedDate: '2025-05-22',
    author: 'Housekaar',
  },
  {
    id:'vastu-kitchen',
    title: 'Top 5 Vastu Tips for a Prosperous Kitchen in Your Bihar House Plan',
    excerpt:
      "Discover the top 5 Vastu tips to design a prosperous kitchen in your Bihar home. Learn about ideal directions, stove placement, and harmonious element integration for health and abundance.",
    tags: ['Vastu kitchen', 'kitchen design', 'Bihar kitchen Vastu', 'Vastu tips', 'prosperous kitchen', 'home Vastu', 'Bihar home design'],
    imageUrl: kitchenImage,
    link:'/blog/top-5-vastu-tips-prosperous-kitchen-bihar',
    publishedDate: '2025-05-22',
    modifiedDate: '2025-05-22',
    author: 'Housekaar',
  },
   {id:'vastumain',
    title: 'Choosing the Right Direction for Your Main Entrance: A Vastu Guide for Bihar Homeowners',
    excerpt:
      "Unlock positive energy and good fortune! This Vastu guide for Bihar homeowners explains the ideal directions for your main entrance to ensure prosperity and harmony in your dream home.",
    tags: ['Vastu main entrance', 'main door Vastu', 'Bihar home Vastu', 'auspicious entrance', 'Vastu directions', 'home prosperity', 'Bihar house plan'],
    imageUrl: mainEntranceImage,
    link:'/blog/choosing-right-direction-main-entrance-vastu-bihar',
    publishedDate: '2025-05-22',
    modifiedDate: '2025-05-22',
    author: 'Housekaar',
  },
  {
    id:'vastuhomes',
    title: 'Vastu-Compliant House Plans for Your Dream Home in Bihar: Everything You Need to Know',
    excerpt:
      'Unlock positive energy and harmony in your Bihar home with Vastu-compliant house plans. Learn essential principles for plot selection, room placement, and more to build your dream home.',
    tags: ['Vastu', 'Vastu Shastra', 'Bihar house plans', 'Vastu compliant homes', 'home design', 'architecture', 'Indian architecture', 'Patna', 'Bhagalpur'],
    imageUrl: blenderSceneImage,
    link:'/blog/vastuhome',
    publishedDate: '2025-05-22', // Example date
    modifiedDate: '2025-05-22', // Example date
    author: 'Housekaar',
  },
  {
    id:'smalloffice-design',
    title: 'Beyond the Cubicle: How to Design a Small Office Space That Inspires Productivity',
    excerpt:
      'Feeling cramped in your small office? Discover smart furniture, clever layouts, and design hacks to transform any tiny workspace into a highly productive and inspiring environment.',
    tags: ['small office design', 'home office ideas', 'office space optimization', 'productivity hacks', 'compact office furniture', 'ergonomic office', 'work from home setup', 'office organization'],
    imageUrl: smallOfficeAfterImage, // Main featured image
    link:'/blog/small-office-design',
    publishedDate: '2025-05-21', // Today's date
    modifiedDate: '2025-05-21', // Today's date
    author: 'Housekaar Design Team', // Assuming this is your author
  },
  {
    id:'avoid_mistakes',
    title: 'Avoiding the Top 5 Mistakes New Home Builders Make',
    excerpt:
      'Embarking on building your dream home? Learn from the experiences of others and avoid these top 5 common mistakes new home builders often make.',
    tags: [
      'new home construction mistakes',
      'home building errors',
      'avoid construction pitfalls',
      'house building tips',
      'new home advice',
    ],
    imageUrl: checklistImage,
    link:'/blog/avoiding-mistakes',
    publishedDate: '2025-05-20',
    modifiedDate: '2025-05-20',
    author: 'Housecar Design Team',
  },
   {
    id:'newhome',
    title: 'The Ultimate New Home Construction Checklist: From Dream to Keys',
    excerpt:
      'Building your dream home can be overwhelming. This ultimate checklist guides you through every step, from initial planning to moving in.',
    tags: [
      'new home construction',
      'home building checklist',
      'dream home',
      'construction process',
      'house planning',
    ],
    imageUrl: checklistImage,
    link:'/blog/new-house-construction',
    publishedDate: '2025-05-20',
    modifiedDate: '2025-05-20',
    author: 'Housekaar',
  },
  {
    id:'free-house-plan',
    title: 'Designing Your Dream Home: A Guide to Creating a Free House Plan (Ghar ka Nakasha)',
    excerpt:
      'Learn practical methods and resources for creating your own house plan (ghar ka nakasha) for free, from initial sketches to online tools.',
    tags: ['house plan', 'ghar ka nakasha', 'free design', 'DIY home', 'architecture basics'],
    imageUrl: imgfree_house,
    link:'/blog/freehouseplanguide',
    publishedDate: '2025-05-16T13:00:00+00:00',
    modifiedDate: '2025-05-16T13:00:00+00:00', // Assuming same day for initial creation
    author: 'Housekaar',
  },
   {
    id:'house-imp',
    title: 'Your Dream Home Starts Here: Understanding the Blueprint - House Plan',
    excerpt:
      'Thinking of building a home in Patna? Learn why a house plan is the crucial first step and why choosing a professional is the smartest decision.',
    tags: ['house plan', 'floor plan', 'home design', 'construction Patna', 'architect Patna'],
    imageUrl: simpleHousePlanImage,
    link:'/blog/houseplanguide',
    publishedDate: '2025-05-11',
    modifiedDate: '2025-05-11',
    author: 'Housekaar Design Team',
  },
  {
    id:'3d-blender',
    title: 'From AutoCAD Lines to Stunning 3D Interiors: A Blender Journey',
    excerpt:
      'Witness the magic! Learn how we transform precise AutoCAD drawings into immersive 3D interior designs using Blender and Cycles rendering.',
    tags: ['3D design', 'interior design', 'Blender', 'AutoCAD', 'visualization', 'rendering'],
    imageUrl: blenderSceneImage,
    link:'/blog/3d-blender',
    publishedDate: '2025-05-03', // Example date
    modifiedDate: '2025-05-03', // Example date
    author: 'Housekaar 3D Visualization Team',

  },
    {
        id:'ghar-ka-naksaha-samje',
        title: 'अपनी नई घर की योजना कैसे बनाएं: सपनों को हकीकत में बदलें!',
      excerpt:
        'बिहार में अपना नया घर बनाने की सोच रहे हैं? यह आसान गाइड आपको बताएगा कि अपनी घर की योजना कैसे बनाएं और अपने सपनों का घर साकार करें।',
      tags: ['घर की योजना', 'नया घर', 'मकान बनाना', 'हाउस प्लानिंग', 'बिहार में घर'],
      imageUrl: housePlanningImage,
      link: "/blog/apni-nayi-ghar-ki-yojana-kaise-banaye",
      publishedDate: '2025-04-30',
      modifiedDate: '2025-04-30',
      author: 'हाउसकार डिज़ाइन टीम',
      },
      {
        id:'strong-house-blog',
        title: 'मज़बूत घर बनाने के लिए महत्वपूर्ण बातें: टिकाऊ और सुरक्षित निवास!',
      excerpt:
        'बिहार में एक मजबूत और टिकाऊ घर बनाने के लिए किन बातों का ध्यान रखना चाहिए? जानें नींव, सामग्री, निर्माण प्रक्रिया और गुणवत्ता नियंत्रण के बारे में।',
      tags: ['मज़बूत घर', 'घर का निर्माण', 'टिकाऊ घर', 'निर्माण सामग्री', 'गुणवत्ता नियंत्रण'],
      imageUrl: strongHouseImage,
      link: "/blog/mazboot-ghar-banane-ke-liye-mahatvapurna-batein",
      publishedDate: '2025-05-02',
      modifiedDate: '2025-05-02',
      author: 'हाउसकार डिज़ाइन टीम',
      },
      {
        id:'ghar-ka-naksha',
        title: 'घर के नक्शे को कैसे समझें: लाइनों और प्रतीकों का रहस्य!',
        excerpt:
          'बिहार में अपने नए घर के नक्शे को समझना सीखें! यह आसान गाइड आपको दीवारों, दरवाजों, खिड़कियों और अन्य महत्वपूर्ण प्रतीकों को समझने में मदद करेगा।',
        tags: ['घर का नक्शा', 'फ्लोर प्लान', 'हाउस प्लान', 'नक्शा पढ़ना', 'निर्माण डिज़ाइन'],
        imageUrl: blueprintImage, 
        link: "/blog/ghar-ke-nakshe-ko-kaise-samjhe",
        publishedDate: '2025-05-03',
        modifiedDate: '2025-05-03',
        author: 'हाउसकार डिज़ाइन टीम',},
      {
        id:'vatsut-blog-housekkar',
        title: 'वास्तु शास्त्र के अनुसार घर का डिज़ाइन: सुख, समृद्धि और शांति का वास!',
      excerpt:
        'बिहार में वास्तु शास्त्र के सिद्धांतों के अनुसार घर का डिज़ाइन कैसे करें? जानें दिशाओं, कमरों के स्थान और सकारात्मक ऊर्जा के प्रवाह के बारे में।',
      tags: ['वास्तु शास्त्र', 'घर का डिज़ाइन', 'वास्तु टिप्स', 'मकान निर्माण', 'बिहार में वास्तु'],
      imageUrl: vastuShastraImage,
      link: "/blog/vastu-shastra-ke- अनुसार-ghar-ka-design",
      publishedDate: '2025-05-01',
      modifiedDate: '2025-05-01',
      author: 'हाउसकार डिज़ाइन टीम',
      },
      {
        id:'small-house-bihar',
        title: 'छोटे घरों के लिए बेहतरीन डिज़ाइन: कम जगह में पाएं ज़्यादा आराम!',
      excerpt:
        'बिहार में छोटे परिवारों के लिए शानदार घर के डिज़ाइन खोजें! ये डिज़ाइन आरामदायक, कार्यात्मक और बजट-अनुकूल हैं।',
      tags: ['छोटे घर', 'घर का डिज़ाइन', 'स्मॉल हाउस डिज़ाइन', 'किफायती घर', 'बिहार के लिए घर'],
      imageUrl: smallHouseImage,
      link: "/blog/chote-gharon-ke-liye-behtareen-design",
      publishedDate: '2025-04-29',
      modifiedDate: '2025-04-29',
      author: 'हाउसकार डिज़ाइन टीम',
      },
      {
        id: 'bihar-home-cost',
        title: 'बिहार में घर बनाने की लागत: आपके सपनों का घर, आपके बजट में!',
      excerpt:
        'जानिए बिहार में घर बनाने की अनुमानित लागत। निर्माण सामग्री, श्रम, डिज़ाइन और अन्य महत्वपूर्ण कारकों के बारे में विस्तृत जानकारी प्राप्त करें।',
      tags: ['घर का निर्माण', 'बिहार', 'निर्माण लागत', 'मकान निर्माण', 'घर का नक्शा'],
      imageUrl: biharcostImage,
      link: "/blog/bihar-me-ghar-banane-ki-lagat",
      publishedDate: '2025-04-28',
      modifiedDate: '2025-04-28',
      author: 'हाउसकार डिज़ाइन टीम',
      },
      {
        id: 'blue-print-symbols-guide',
        title: 'Blueprint Secrets REVEALED! Your Quick Guide to 2D Floor Plan Symbols',
        excerpt:
        'Unlock the mysteries of architectural blueprints! This quick and easy guide deciphers common 2D floor plan symbols, making them simple to understand.',
        tags: ['architecture', 'floor plan', 'design', 'symbols', 'blueprint'],
        imageUrl: blueprintImage,
        link: "/blog/blue-print-symbols-guide",
        publishedDate: '2025-04-27', // Example date
        modifiedDate: '2025-04-27', // Example date
        author: 'Housekaar Design Team',
      },
      {
        id: 'understanding-elevation-in-construction',
        title: 'Understanding Elevation in Construction: A Housekaar Explanation',
        excerpt:
          'Have you ever wondered what "elevation" truly means in the world of construction and architecture? Housekaar Construction breaks down this crucial concept...',
        tags: ['construction', 'architecture', 'design', 'elevation'],
        imageUrl: img,
        link: '/blog/understanding-elevation-in-construction',
        publishedDate: '2025-04-22T19:00:00+00:00',
        modifiedDate: '2025-04-22T19:00:00+00:00',
        author: 'Housekaar',
      },
      {
        id: 'modern-home-design-2024',
        title: 'The Evolving Landscape of Modern Home Design in 2024',
        excerpt:
          'Explore the key shifts and exciting innovations in modern home design, focusing on sustainability, smart home integration, and biophilic elements.',
        tags: ['architecture', 'modern design', 'sustainability', 'smart home'],
        imageUrl: img2,
        link: '/blog/modern-home-design-2024',
        publishedDate: '2024-03-15T14:00:00+00:00',
        modifiedDate: '2024-03-22T10:30:00+00:00',
        author: 'Housekaar',
      },
      {
        id: 'cost-effective-interior-design',
        title: 'Budget-Friendly Interior Design: Creating Style Without Breaking the Bank',
        excerpt:
          'Discover practical and creative strategies for achieving a stylish and comfortable interior without exceeding your budget. Learn about smart shopping and DIY solutions.',
        tags: ['interior design', 'budget', 'decor', 'DIY'],
        imageUrl: img3,
        link: '/blog/cost-effective-interior-design',
        publishedDate: '2024-02-28T09:30:00+00:00',
        modifiedDate: '2024-03-05T16:00:00+00:00',
        author: 'Housekaar',
      },
      {
        id: 'sustainable-construction-patna',
        title: 'Embracing Sustainable Construction Practices in Patna',
        excerpt:
          'An in-depth look at the growing importance of sustainable building in Patna, highlighting eco-friendly materials and energy-efficient construction techniques relevant to the local climate.',
        tags: ['construction', 'sustainability', 'eco-friendly', 'Patna'],
        imageUrl: img4,
        link: '/blog/sustainable-construction-patna',
        publishedDate: '2024-01-20T11:00:00+00:00',
        modifiedDate: '2024-01-28T18:00:00+00:00',
        author: 'Housekaar',
      },
      {
        id: 'smart-kitchen-design',
        title: 'Designing the Intelligent Kitchen: Integrating Smart Technology for Convenience',
        excerpt:
          'Explore the latest smart kitchen appliances and design concepts that enhance functionality, efficiency, and convenience in the heart of your home.',
        tags: ['interior design', 'kitchen', 'smart home', 'technology'],
        imageUrl: img5,
        link: '/blog/smart-kitchen-design',
        publishedDate: '2023-12-10T16:45:00+00:00',
        modifiedDate: '2023-12-18T12:00:00+00:00',
        author: 'Housekaar',
      },
      
];

export default blogPostsData;